<!--  -->
<template>
  <div class="uploadBox">
    <div class="fileClassDiv">+</div>
    <div class="prompt">{{ upload_text }}</div>
    <input
      class="fileClassInput"
      id="fileClassInput"
      @change="handleOnChangeFile"
      type="file"
      :accept="upload_accept"
    />
    <img :src="imgSrc" id="credentials" class="credentials" @click="handleImg($event)" />
    <div @click="handleDeleteImg" v-if="close_credentials" class="close_credentials" id="close_credentials">
      <van-icon name="close" />
    </div>
    <big-img v-if="showImg" @clickit="viewImg" :imgSrc="state_imgSrc"></big-img>
  </div>
</template>



<script>
import axios from "axios";
import BigImg from "../components/bigImg";
export default {
  name: "uploader",
  data() {
    return {
      showImg: false,
      state_imgSrc: "",
    };
  },
  props: {
    upload_text: {
      //默认文本
      type: String,
      default: "上传文件",
    },
    upload_accept: {
      //按钮1文案
      type: String,
      default: "image/gif, image/jpeg, image/jpg, image/png, image/svg",
    },
    imgSrc: {
      type: String,
      // default: require("../../../assets/debtor/user.png"),
    },
    close_disable: {
      type: Boolean,
      default: true,
    },
    close_credentials:{
       type: Boolean,
      default: true,
    }
  },
  components: {
    "big-img": BigImg,
  },
  mounted() {
  
    setTimeout(() => {
      const img = document.getElementById("credentials");
      img.style.display = this.imgSrc ? "block" : "none";
      const close = document.getElementById("close_credentials");
      close.style.display =
        this.close_disable && this.imgSrc ? "block" : "none";
    }, 300);
  },
  methods: {
    // 查看大图
    handleImg(e) {
      this.showImg = true;
      this.state_imgSrc = e.currentTarget.src;
    },
    viewImg() {
      this.showImg = false;
    },
    handleOnChangeFile(info) {
      this.$api
        .post("contract/member/file/update/token", { type: "debt" })
        .then((res) => {
          let f = document.getElementById("fileClassInput").files[0];
          let formData = new FormData();
          let blob = new Blob([f]);
          formData.set("file", blob);
          formData.set("token", res.token);
          formData.set("key", res.file_path + ".png");
            // console.log(1,this.close_disable)
          axios
            .post("https://up-z0.qiniup.com", formData)
            .then((res) => {
              this.$emit("handleOnChangeFile1", { key: res.key });
              var reads = new FileReader();
              const img = document.getElementById("credentials");
              const close = document.getElementById("close_credentials");
              let f = document.getElementById("fileClassInput").files[0];
              reads.readAsDataURL(f);
              reads.onload = function (e) {
                this.imgSrc = this.result;
                img.style.display = "block";
              close.style.display =  "block" ;
                img.src = this.result;
                info.target.value = "";
              };
            })
            .catch((err) => {
              // reject(err);
              this.$toast('图片上传失败，请重新上传')
            });

          //  this.http.post('https://up-z2.qiniup.com',formData).toPromise().then(res1=>{
          // }).catch(error => {
          // });
        });
    },
    handleDeleteImg() {
      const img = document.getElementById("credentials");
      const close = document.getElementById("close_credentials");
      this.imgSrc = "";
      img.style.display = "none";
      close.style.display = "none";
      this.$emit("handleOnChangeFile1", { key: "" });
    },
    // watch: {},
  },
  upload(){
//  console.log(this.close_disable , this.imgSrc)
  }
};
</script>

<style scoped lang='less'>
.uploadBox {
  position: relative;
  width: 100px;
  margin-top: 18px;
}
.fileClassDiv {
  border: 2px dashed #dedede;
  font-size: 35px;
  width: 96px;
  height: 76px;
  color: #999999;
  text-align: center;

  padding-top: 20px;
}
.prompt {
  font-size: 13px;
  width: 96px;
  color: #999999;
  text-align: center;
  position: absolute;
  bottom: 30px;
}
.fileClassInput {
  opacity: 0;
  width: 100px;
  height: 100px;
  position: absolute;
  margin: -100px 0 0;
}
.credentials {
  display: none;
  position: absolute;
  width: 100px;
  height: 100px;
  top: 0;
}
.close_credentials {
  display: none;
  position: absolute;
  top: -4px;
  right: -5px;
}
</style>
